export class Source {
  UserSourceId: number=0;
  Id: number=0;
  SourceCode: string="";
  SourceName: string="";
  Site: string="";
  //Tests: Test[];
}
